export default {
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    EMAIL: 'EMAIL',
    PROFILE: 'PROFILE',
    LOGIN: 'LOGIN',
    SOCIETY: 'SOCIETY',
    SHOP: 'SHOP'
};



// WEBPACK FOOTER //
// ./src/enums/SortableUserColumnsEnum.js